export default __webpack_public_path__ + "static/1145-f71417922f0d1f677b6d603407b431f6.gif";